import { clientsConstants } from "../constants/action.constants";

const initialState = {
  fetching: false,
  fetched: false,
  response: null,
  error: null
};

export const clients = (state = initialState, action) => {
  switch (action.type) {
    case clientsConstants.GET_CLIENTS_REQUEST:
      return {
        ...state,
        fetching: true
      };
    case clientsConstants.GET_CLIENTS_SUCCESS:
      return {
        ...state,
        fetching: false,
        fetched: true,
        response: action.response,
        error: null
      };
    case clientsConstants.GET_CLIENTS_FAILURE:
      return {
        ...state,
        fetching: false,
        fetched: false,
        error: action.error
      };
    case clientsConstants.GET_CLIENTS_RESET:
      return {
        ...state,
        ...initialState
      };
    default:
      return state;
  }
};
